import WarningModal from "app/storybookComponents/Modals/WarningModal";

interface Props {
  isOpen: boolean;
  onHide: () => void;
  alertId: number | null;
  isInProgress?: boolean;
  onConfirmClick: (alertId: number) => void;
}

const DismissConcernModal = ({
  isOpen,
  onHide,
  alertId,
  isInProgress,
  onConfirmClick,
}: Readonly<Props>) => (
  <WarningModal
    modalTitle="Dismiss Concern Alert"
    hideModal={onHide}
    isOpen={isOpen}
    onConfirmClick={() => {
      if (alertId !== null) {
        onConfirmClick(alertId);
      }
    }}
    warningTitle="Dismiss this concern alert?"
    warningMessage="This will dismiss the alert for all managers in your organization. This action cannot be undone."
    customButtonText="Dismiss Alert"
    isDanger
    isInProgress={isInProgress}
  />
);

export default DismissConcernModal;
